import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d08a30b4")

_pushScopeId("data-v-d08a30b4")
const _hoisted_1 = { class: "dt-open-api-app-info clearfix" }
const _hoisted_2 = { class: "dt-open-api-app-info-content" }
const _hoisted_3 = { class: "dt-open-api-app-info-content-app-name" }
const _hoisted_4 = { class: "dt-open-api-app-info-content-app-type-name" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        class: "dt-open-api-app-info-img",
        src: `${_ctx.aliyunPath}${_ctx.application.logo}`
      }, null, 8, ["src"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("p", _hoisted_3, _toDisplayString(_ctx.application.title), 1),
        _createVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.application.categoryName) + " ", 1 /* TEXT */),
          _hoisted_5
        ])
      ])
    ])
  ]))
})